exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:fontello;src:url(" + require("./fontello.eot") + ");src:url(" + require("./fontello.woff2") + ") format(\"woff2\"),url(" + require("./fontello.woff") + ") format(\"woff\"),url(" + require("./fontello.ttf") + ") format(\"truetype\"),url(" + require("./fontello.svg") + ") format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-\"]:before,[class^=icon-]:before{font-family:fontello;font-style:normal;font-weight:400;speak:none;display:inline-block;text-decoration:inherit;width:1em;margin-right:.2em;text-align:center;font-variant:normal;text-transform:none;line-height:1em;margin-left:.2em;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-play:before{content:\"\\E800\"}.icon-download-alt:before{content:\"\\E801\"}.icon-docs:before{content:\"\\F0C5\"}.icon-attention-alt:before{content:\"\\F12A\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/demo-ui/asset/icon-font/fontello.min.css
// module id = 498
// module chunks = 0